import { post, putFileToUrl, resolveApiUrl, uploadFile } from './api'

export interface UploadedFile {
  id?: string
  path: string
  url: string
  pageCount?: number
  sizeBytes?: number
  mimeType?: string
}

interface UploadTicket {
  mode: 'direct' | 'proxy'
  key?: string
  uploadUrl?: string
  contentType?: string
  ticket?: { payload: Record<string, unknown>; signature: string }
}

export async function uploadBlob(file: File): Promise<UploadedFile> {
  // mimeType 用 file.type（与浏览器 PUT 自动携带的 Content-Type 同源），
  // 直传时回传 ticket 下发的 contentType，保证与签名值逐字节一致。
  const ticket = await post<UploadTicket>('/storage/upload-ticket', {
    size: file.size,
    name: file.name,
    mimeType: file.type || '',
  })
  if (ticket.mode === 'direct') {
    if (!ticket.key || !ticket.uploadUrl || !ticket.ticket) throw new Error('上传票据无效')
    await putFileToUrl(ticket.uploadUrl, file, ticket.contentType)
    const verified = await post<UploadedFile>('/storage/upload-verify', {
      key: ticket.key,
      name: file.name,
      ticket: ticket.ticket,
    })
    return { ...verified, url: resolveApiUrl(verified.url) }
  }
  const data = await uploadFile<UploadedFile>('/storage/upload', file)
  return { ...data, url: resolveApiUrl(data.url) }
}
